import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { pxToRem } from '../../../commonUtils/resizeUtils';

interface IProps {
  currentPage: number;
  totalPages: number;
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  disabledPrevious?: boolean;
  disabledNext?: boolean;
  isPalButton?: boolean;
}

export const PaginationButton = (props: IProps) => {
  const {
    currentPage,
    totalPages,
    onPreviousClick,
    disabledPrevious,
    disabledNext,
    onNextClick,
    isPalButton,
  } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '4px',
        width: { xs: isPalButton ? 'initial' : '100%', md: 'initial' },
        paddingLeft: { xs: pxToRem(10), md: 0 },
        paddingRight: { xs: pxToRem(10), md: 0 },
      }}
    >
      <PrevButton
        disabled={disabledPrevious}
        onPreviousClick={onPreviousClick}
        isPalButton={isPalButton}
      />
      <NumberButton
        currentPage={currentPage}
        totalPages={totalPages}
        isPalButton={isPalButton}
      />
      <NextButton
        disabled={disabledNext}
        onNextClick={onNextClick}
        isPalButton={isPalButton}
      />
    </Box>
  );
};

const PalButton = (props: {
  onClick?: () => void;
  disabled?: boolean;
  children: any;
  noHoverEffect?: boolean;
}) => {
  const { onClick, disabled, noHoverEffect, children } = props;
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      sx={{
        justifySelf: 'center',
        background: 'linear-gradient(135deg, #66bb6a 0%, #4caf50 100%)',
        color: 'white',
        px: 5,
        py: 1.25,
        borderRadius: 2,
        fontWeight: 700,
        fontSize: 15,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        boxShadow: '0 4px 16px rgba(76,175,80,0.3)',
        '&:hover': noHoverEffect
          ? {}
          : {
              background: 'linear-gradient(135deg, #4caf50 0%, #43a047 100%)',
              boxShadow: '0 8px 24px rgba(76,175,80,0.4)',
            },
        '&:disabled': {
          background: '#d1d5db',
          color: '#9ca3af',
          boxShadow: 'none',
        },
      }}
    >
      {children}
    </Button>
  );
};

interface PrevButtonProps {
  onPreviousClick?: () => void;
  disabled?: boolean;
  isPalButton?: boolean;
}

const PrevButton = (props: PrevButtonProps) => {
  if (props.isPalButton) {
    return (
      <PalButton
        onClick={props.onPreviousClick}
        disabled={props.disabled}
        children="Prev"
      />
    );
  }
  return (
    <Button
      sx={{
        width: { xs: '30%', md: pxToRem(110) }, //130
        height: { xs: '58px', md: pxToRem(40), lg: pxToRem(50) }, //60
        fontFamily: 'Poppins',
        fontWeight: 700,
        fontSize: { xs: '18px', md: pxToRem(21) },
        boxShadow: 'inset 0px 0px 8px #00602B,0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px 0px 0px 10px',
        '&:disabled': {
          cursor: 'not-allowed',
          backgroundColor: 'neutral.grey',
        },
      }}
      variant="contained"
      color="secondary"
      onClick={props.onPreviousClick}
      disabled={!!props.disabled}
    >
      Prev
    </Button>
  );
};

interface NumberButtonProps {
  currentPage: number;
  totalPages: number;
  isPalButton?: boolean;
}

const NumberButton = (props: NumberButtonProps) => {
  if (props.isPalButton) {
    return (
      <PalButton
        children={`${props.currentPage}/${props.totalPages}`}
        noHoverEffect
      />
    );
  }
  return (
    <Button
      sx={{
        width: { xs: '40%', md: pxToRem(110) },
        height: { xs: '58px', md: pxToRem(40), lg: pxToRem(50) },
        fontFamily: 'Poppins',
        fontWeight: 700,
        fontSize: { xs: '18px', md: '21px' },
        boxShadow: 'inset 0px 0px 8px #00602B,0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '0px 0px 0px 0px',
      }}
      variant="contained"
      color="secondary"
    >
      {props.currentPage}/{props.totalPages}
    </Button>
  );
};

interface NextButtonProps {
  onNextClick?: () => void;
  disabled?: boolean;
  isPalButton?: boolean;
}

const NextButton = (props: NextButtonProps) => {
  if (props.isPalButton) {
    return (
      <PalButton
        onClick={props.onNextClick}
        disabled={props.disabled}
        children="Next"
      />
    );
  }
  return (
    <Button
      sx={{
        width: { xs: '30%', md: pxToRem(110) },
        height: { xs: '58px', md: pxToRem(40), lg: pxToRem(50) },
        fontFamily: 'Poppins',
        fontWeight: 700,
        fontSize: { xs: '18px', md: '21px' },
        boxShadow: 'inset 0px 0px 8px #00602B,0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '0px 10px 10px 0px',
        '&:disabled': {
          cursor: 'not-allowed',
          backgroundColor: 'neutral.grey',
        },
      }}
      variant="contained"
      color="secondary"
      onClick={props.onNextClick}
      disabled={!!props.disabled}
    >
      Next
    </Button>
  );
};
